"use client";

import * as React from "react";

// @components
import { MiniCard } from "@/components";

// @hooks
import { useVariation } from "../store";
import { useRawData } from "@/hooks/use-liquidity";

export function TotalLiquidity() {
  const { data, isLoading } = useRawData();
  const variation = useVariation((state: any) => state.variation);

  const ask = React.useMemo(() => {
    if (!isLoading) {
      if (variation !== "EHEX & PHEX") {
        return data
          .map((x: Record<string, any>) => {
            if (
              x.name0.toUpperCase() === variation ||
              x.name1.toUpperCase() === variation
            ) {
              return x.ask;
            }
          })
          .filter((el: any) => el !== undefined)
          .reduce((x: number, y: number) => x + y, 0);
      }

      return data
        .map((x: Record<string, any>) => x.ask)
        .reduce((x: number, y: number) => x + y, 0);
    }
  }, [data, isLoading, variation]);

  const bid = React.useMemo(() => {
    if (!isLoading) {
      if (variation !== "EHEX & PHEX") {
        return data
          .map((x: Record<string, any>) => {
            if (
              x.name0.toUpperCase() === variation ||
              x.name1.toUpperCase() === variation
            ) {
              return x.bid;
            }
          })
          .filter((el: any) => el !== undefined)
          .reduce((x: number, y: number) => x + y, 0);
      }

      return data
        .map((x: Record<string, any>) => x.bid)
        .reduce((x: number, y: number) => x + y, 0);
    }
  }, [data, isLoading, variation]);

  const totalLiquidity = React.useMemo(() => {
    if (ask && bid) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(ask + bid);
    }
  }, [ask, bid]);

  return (
    <MiniCard title="Total Liquidity:" isLoading={isLoading}>
      {totalLiquidity}
    </MiniCard>
  );
}
